import type { ReactElement } from 'react';

interface LabelLessStateProps {
  label: string;
  description: string;
  /**
   * Explain the state on hover and to screen readers. Off where the
   * explanation is already on screen (the expanded row).
   */
  describe: boolean;
}

/**
 * A cell value that is not a verdict ("No verdict yet", "Not applicable"): muted,
 * ellipsized when the column is narrow, with the full label and why on hover
 * (KIR-4726).
 */
export function LabelLessState({
  label,
  description,
  describe,
}: LabelLessStateProps): ReactElement {
  return (
    <span
      className="inline-flex max-w-full min-w-0 items-center gap-1.5 text-muted-foreground"
      title={describe ? `${label}: ${description}` : label}
    >
      <span
        aria-hidden
        className="size-1.5 shrink-0 rounded-full bg-muted-foreground/50"
      />
      <span className="truncate">{label}</span>
      {describe ? <span className="sr-only">: {description}</span> : null}
    </span>
  );
}

LabelLessState.displayName = 'LabelLessState';
